export default {
  basicelement: {
    searchPlaceholder: '对应参数/批次属性/元素说明',
    codingId: '基础元素',
    codingIdPlaceholder: '请输入[A-Z]任一字符',
    requiredCodingId: '请输入基础元素',
    codeFactor: '编码要素',
    parameter: '对应参数',
    parameterPlaceholder: '输入[standardCol,guestCol,lotAtt]参数',
    requiredParameter: '请输入对应参数',
    lotRule: '批次属性',
    requiredLotRule: '请选择批次属性',
    codingNameIndistinct: '元素说明',
    codingName: '元素说明',
    i18nList: '元素说明',
    inputType: '输入框类型',
    requiredInputType: '请选择输入框类型',
    input: '文本框',
    dateInput: '日期框',
    fieldType: '日期格式',
    partNo: '段次号',
    partRemarks: '段次备注',
    fieldValue: '栏位值',
    leng: '栏位长度',
    simulation: '模拟值',
    remark: '备注',
    statusCode: '状态',
    createDate: '创建时间',
    createName: '创建人员',
    updateDate: '更新时间',
    updateName: '更新人员',
    parameterIndistinct: '对应参数',
    remarkIndistinct: '备注'
  },
  barcoderule: {
    searchPlaceholder: '规则编号/规则名称',
    barRuleNo: '条码规则编号',
    barRuleNoIndistinct: '条码规则编号',
    requiredBarRuleNo: '请输入条码规则编号',
    barRuleNameIndistinct: '条码规则名称',
    barRuleName: '条码规则名称',
    requiredBarRuleName: '请输入条码规则名称',
    barType: '条码类型',
    requiredBarType: '请选择条码类型',
    codeTotal: '总段次',
    detailListTitle: '扫码明细',
    formTitle: '编码明细',
    selectTitle: '选择元素',
    createDate: '创建时间',
    createName: '创建人员',
    updateDate: '更新时间',
    updateName: '更新人员',
    remark: '备注',
    statusCode: '状态',
    remarkIndistinct: '备注',
    partNo: '段次号',
    partRemarks: '段次备注',
    codeFactor: '编码要素',
    fieldType: '日期格式',
    fieldValue: '栏位值',
    leng: '栏位长度',
    simulation: '模拟值'
  },
  batchrule: {
    searchPlaceholder: '规则编号/规则名称',
    lotRuleNoIndistinct: '批次规则编码',
    lotRuleNameIndistinct: '批次规则名称',
    lotRuleNo: '批次规则编码',
    lotRuleName: '批次规则名称',
    requiredLotRuleNo: '请输入批次规则编号',
    requiredLotRuleName: '请输入批次规则名称',
    requiredDetailList: '请添加编码明细',
    formTitle: '编码明细',
    selectTitle: '选择批次',
    lotAtt: '批次属性',
    lotAttValue: '批次属性值',
    isCombinationLotNo: '是否批次拼接',
    dateFormat: '日期格式',
    remark: '备注',
    lotRule: '批次属性',
    codingName: '批次属性值',
    createDate: '创建时间',
    createName: '创建人员',
    updateDate: '更新时间',
    updateName: '更新人员',
    statusCode: '状态',
    remarkIndistinct: '备注',
    partNo: '段次号'
  }
}
